'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dPeriod$0024 from "./presto.types$-Dashboard-Period$.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$11(outer) {
  this.aKn = null;
  this.aKl = null;
  this.aKm = false;
  this.aKj = null;
  this.aKk = false;
  this.aKo = false;
  this.aKp = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aKn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DashboardView$$anon$11 as $c_Lpresto_DashboardView$$anon$11 };
$p = $c_Lpresto_DashboardView$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$11;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$11() {
}
export { $h_Lpresto_DashboardView$$anon$11 as $h_Lpresto_DashboardView$$anon$11 };
$h_Lpresto_DashboardView$$anon$11.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.aKn;
});
$p.t = (function() {
  if ((!this.aKm)) {
    this.aKl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("period", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("host", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKm = true;
  }
  return this.aKl;
});
$p.ad = (function() {
  if ((!this.aKk)) {
    this.aKj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dDashboard$002dPeriod$0024.$m_Lpresto_types$DashboardPeriod$().cHl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().crA()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().ado()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKk = true;
  }
  return this.aKj;
});
$p.v = (function() {
  if ((!this.aKp)) {
    this.aKo = false;
    this.aKp = true;
  }
  return this.aKo;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DashboardView$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$11, "presto.DashboardView$$anon$11", ({
  H9: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$11 as $d_Lpresto_DashboardView$$anon$11 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$11.js.map
